import { render, staticRenderFns } from "./platPane.vue?vue&type=template&id=56c96283"
import script from "./platPane.vue?vue&type=script&lang=js"
export * from "./platPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports